<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <ValidationProvider
          name="tipo"
          rules="required"
          v-slot="{ errors }"
          :custom-messages="{ required: 'El tipo es obligatorio' }"
        >
          <label for="selectDocumentos">Tipo</label>
          <select id="selectDocumentos" class="custom-select" v-model="currentDocumento.tipo">
            <option v-for="option in optionsInternal" :key="option.value">
              {{ option.text }}
            </option>
          </select>
          <base-input
            type="text"
            placeholder="Tipo de documento"
            v-model="currentDocumento.descripcion"
            v-if="currentDocumento.tipo === 'Otro'"
            class="mt-2"
          ></base-input>

          <span class="cardErrors">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
      <div class="col-md-6">
        <ValidationProvider
          name="documento"
          rules="required"
          v-slot="{ errors }"
          :custom-messages="{ required: 'El documento es obligatorio' }"
        >
          <label for="">Documento</label>
          <b-form-file
            v-model="currentDocumento.file"
            browse-text="Seleccionar"
            drop-placeholder="Cargar aquí"
            placeholder="Da click aquí o arrastra el archivo"
            :accept="acceptedFileTypes"
            @input="onInput"
          />
          <p class="orange-italic-13p-text" style="margin-top: 1rem" v-if="!isStaff">Tamaño máximo del archivo: 25 MB</p>
          <p class="orange-italic-13p-text" v-if="acceptedFileTypes === 'application/pdf'">
            Favor de subir archivos PDF (.pdf) únicamente.
          </p>
          <span class="cardErrors">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
    </div>

    <label class="mt-4 leyenda" v-if="currentDocumento.tipo === 'Cuadro de distribución accionaria'">
      Del análisis del cuadro, el staff te contactará para solicitar la información requierida de los beneficiarios controladores.
    </label>

    <div class="text-center mt-5">
      <button type="submit" class="btn btn-fill float-right orange-btn">Guardar</button>
    </div>
  </div>
</template>

<script>
import Storage from "@/utils/storage";

const storage = new Storage();

export default {
  name: "ModalDocumentos",

  props: {
    currentDocumento: { type: Object },
    // id,
    // documento,
    // cat_documentos_id,
    // activo,
    // creado,
    // actualizado,
    // auto_referencia,
    // descripcion,
    // paginas,
    // copias_certificadas,
    // nombre,
    // fecha,
    // idioma_extranjero,
    // file,
    // tipo,
    // nombreFile,
    options: { type: Array },
    optionsRO: {
      type: Array,
      default: () => [],
    },
    acceptedFileTypes: {
      type: String,
      default: "application/pdf",
    },
  },

  created() {
    this.optionsInternal = structuredClone(this.options);

    if (this.currentDocumento.cat_documentos_id) {
      const index = this.optionsRO.findIndex((d) => Number(d.value) === Number(this.currentDocumento.cat_documentos_id));

      if (index !== -1) {
        this.optionsInternal.push(this.optionsRO[index]);
      }
    }

    this.isStaff = storage.getItem("role").toLowerCase().includes("staff");
  },

  data() {
    return {
      optionsInternal: [],
      isStaff: false,
    };
  },

  computed: {},

  methods: {
    onInput(inputFile) {
      const acceptedFileTypesSplitted = this.acceptedFileTypes.split(",");

      if (!acceptedFileTypesSplitted.includes(inputFile.type)) {
        this.$toast.error("Tipo de archivo no aceptado.", {
          timeout: 4000,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });

        this.currentDocumento.file = null;
        return;
      }

      if (!this.isStaff && inputFile.size > 26214400) {
        this.$toast.error(
          "El archivo que desea cargar no puede ser mayor a 25 MB, si es el caso, envíe un correo a info@correduriadigital.mx.",
          {
            timeout: 6000,
            hideProgressBar: false,
            position: "top-right",
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            closeButton: "button",
            icon: true,
          },
        );

        this.currentDocumento.file = null;
        return;
      }
    },
  },
};
</script>
